<p class="input-error text-danger" [class.remove-margin]="removeMargin">
  {{ message }}
</p>
